'use strict';

angular.module('ClinicApp').directive('appointmentTimeSelector', function() {
  return {
    templateUrl: '/views/directives/_appointment-time-selector.html',
    require: 'ngModel',
    scope: {
      appointment: '=',
      provider: '=',
      formSubmitted: '=',
      pastTimeEnabled: '=',
      futureTimeEnabled: '=',
      pastTimeError: '=',
      futureTimeError: '=',
      slot: '=',
    },
    link: function($scope, _el, _attrs, ctrl) {
      $scope.ngModelCtrl = ctrl;

      $scope.hourOptions = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
      $scope.minuteOptions = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
      $scope.intervalOptions = ['AM', 'PM'];

      function update() {
        var params = _.pick($scope.userSelected, ['date', 'hour', 'minute', 'interval']);
        if (params.date && params.hour && params.minute && params.interval) {
          var datetime = moment(params.date + ' ' + params.hour + ':' + params.minute + ' ' + params.interval, 'D MMMM, YYYY hh:mm A');
          ctrl.$setViewValue(datetime);
        } else {
          ctrl.$setViewValue(null);
        }
      }

      ctrl.$validators.past = function(modelValue) {
        return $scope.pastTimeEnabled || moment(modelValue).isAfter();
      };

      ctrl.$validators.future = function(modelValue) {
        return $scope.futureTimeEnabled || moment(modelValue).isBefore();
      };

      ctrl.$validators.warnings = function(modelValue) {
        ctrl.$warning = {};
        var datetime = moment(modelValue);
        var startTime = datetime.diff(moment(datetime).startOf('day'), 'minutes');
        var providerDayHours = _.get($scope.provider, 'hours[' + datetime.day() + ']');
        ctrl.$warning.outsideProviderHours = !!(
          providerDayHours
          && (startTime < providerDayHours.start || startTime >= providerDayHours.end)
        );
        return true;
      };

      ctrl.$formatters.unshift(function(value) {
        if (value === null) {
          $scope.userSelected = {};
        }
      });

      $scope.$watch('userSelected.date', update);
      $scope.$watch('userSelected.hour', update);
      $scope.$watch('userSelected.minute', update);
      $scope.$watch('userSelected.interval', update);
      $scope.$watch('provider', update);
    },
  };
});
